export class WindowRefServiceStub {
  get nativeWindow(): any {
    return {
      open: () => {}
    };
  }
}
